"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.developerErrorLocalization = void 0;
/**
 * @internal
 */
exports.developerErrorLocalization = {
    getTx: (message) => message,
    glCompileError: "Failed to compile program, errors / warnings follow:",
};
//# sourceMappingURL=developer-error-localization.js.map